import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { ContextProvider } from 'Redux/context';
import GlobalStyle from './GlobalStyle';
import { store } from './Redux/store';
import Routes from './Routers/Routes';
import { MexlogTheme } from './Utils/Themes';
import { Toaster } from 'sonner';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={MexlogTheme}>
        <GlobalStyle />
        <ContextProvider>
          <Routes />
          <Toaster />
        </ContextProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
